(function ($) {
    // Toggle menu (mobile)
    $('.m-menu__mobile-toggle').bind('click', function () {
        $('.m-header__menu-mobile').toggleClass(
            'm-header__menu-mobile--isactive'
        );
        $('.m-header__menu-mobile-close').toggleClass(
            'm-header__menu-mobile-close--isactive'
        );
        $('.m-menu__mobile-toggle').toggleClass(
            'm-menu__mobile-toggle--isactive'
        );
    });

    // Close menu (mobile)
    $('.m-header__menu-mobile-close').bind('click', function (e) {
        $(this).removeClass('m-header__menu-mobile-close--isactive');
        $('.m-header__menu-mobile').removeClass(
            'm-header__menu-mobile--isactive'
        );
        $('.m-menu__mobile-toggle').removeClass(
            'm-menu__mobile-toggle--isactive'
        );
        e.preventDefault();
    });

    // Sub-menus (mobile)
    $('.m-menu__mobile .menu-item-has-children > a').each(function () {
        $(this).bind('click', function (e) {
            // First click opens the menu, second goes to page
            if (!$(this).parent().hasClass('m-menu__mobile--opensub')) {
                $(this).parent().addClass('m-menu__mobile--opensub');
                e.preventDefault();
            }
        });
    });

    // Toggle menu (secondary)
    $('.m-menu__secondary-toggle').bind('click', function () {
        $(this).toggleClass('m-menu__secondary-toggle--isactive');
        $('.m-header__menu-secondary').toggleClass(
            'm-header__menu-secondary--isactive'
        );
        //$(".m-header__menu-secondary-close").toggleClass("m-header__menu-secondary-close--isactive");
        $('.m-menu__secondary-toggle-container').toggleClass(
            'm-menu__secondary-toggle-container--isactive'
        );
    });

    // Close menu (secondary)
    $('.m-header__menu-secondary-close').bind('click', function (e) {
        $(this).removeClass('m-header__menu-secondary-close--isactive');
        $('.m-header__menu-secondary').removeClass(
            'm-header__menu-secondary--isactive'
        );
        $('.m-menu__secondary-toggle').removeClass(
            'm-menu__secondary-toggle--isactive'
        );
        $('.m-menu__secondary-toggle-container').removeClass(
            'm-menu__secondary-toggle-container--isactive'
        );
        e.preventDefault();
    });

    // Open sub-menu (primary)
    $('.m-menu__primary > ul > .menu-item > a').each(function () {
        $(this).bind('focus mouseover', function (e) {
            $('.m-menu__primary--opensub').removeClass(
                'm-menu__primary--opensub'
            );

            if ($(this).parent().hasClass('menu-item-has-children')) {
                $(this).parent().addClass('m-menu__primary--opensub');
            }
        });
    });

    // Close sub-menu (primary)
    $('.m-header').bind('clickoutside focusoutside', function () {
        $('.m-menu__primary--opensub').removeClass('m-menu__primary--opensub');
    });

    // Toggle search form
    $('.m-header__search button').bind('click', function () {
        $('.m-header__search').toggleClass('m-header__search--isactive');

        if ($('.m-header__search').hasClass('m-header__search--isactive')) {
            $('.m-header__search input').focus();
        }
    });
})(jQuery);
